/* eslint-env jquery */
import { header } from '../scripts';
const $ = jQuery;
const blogTOC = $('.blog-table-of-contents');
if (blogTOC.length) {
  blogToC();
}

if (
  $('body').hasClass('blog') ||
  $('body').hasClass('single-post') ||
  $('body').hasClass('archive')
) {
  $(document).ready(blogMatchHeight);
  $(window).on('resize', blogMatchHeight);
}

isResized();
if ($('.blog-header-col .blog-image').length) {
  blogImage();
}

function blogToC() {
  $('main').css('overflow', 'unset');

  const blogHeader = $('.blog-header');
  const siteFooter = $('footer');

  $('.progress-line').css('height', '15px');
  $('.toc-menu').find('li:first').addClass('active');

  const tocContents = blogTOC.html();

  if (blogTOC.length > 0) {
    $('.toc-mobile').append(`<div class="blog-table-of-contents">${tocContents}</div>`);
  }

  const blogTOCmobile = $('.toc-mobile .blog-table-of-contents');
  blogTOCmobile.css('height', 0);

  $(document).on('click', '.toc-mobile li a', () => {
    $('.toc-mobile').find('.blog-table-of-contents').animate(
      {
        height: 0
      },
      100
    );
    $('body').removeClass('toc-lock');
    $('.toc-mobile').removeClass('toc-active');
  });

  $(document).on('click', '.toc-mobile-trigger', function () {
    $(this).parent().toggleClass('toc-active');
    $('body').toggleClass('toc-lock');
    if ($('.toc-mobile').hasClass('toc-active')) {
      $(this)
        .parent()
        .find('.blog-table-of-contents')
        .animate(
          {
            height: $('.toc-mobile .blog-table-of-contents').get(0).scrollHeight
          },
          200,
          function () {
            $(this).height('auto');
          }
        );
    } else {
      $(this).parent().find('.blog-table-of-contents').animate(
        {
          height: 0
        },
        100
      );
    }
  });

  $(window).scroll(() => {
    const windowpos = $(window).scrollTop();
    const windowheight = $(window).height();

    if (windowpos < blogHeader.outerHeight()) {
      $('.toc-menu li').removeClass('passed');
    }

    if (windowpos + windowheight < siteFooter.offset().top) {
      $('.blog-content-container')
        .children()
        .each(function () {
          const section = $(this);
          const sectionID = $(this).attr('id');

          if (sectionID) {
            const selector = `.toc-menu > li > a[href=#${sectionID}]`;
            if (
              $(selector).length > 0 &&
              windowpos + 2 >= section.offset().top - header.outerHeight() - 150
            ) {
              // 2 value is a buffer to trigger it 2pixels earlier
              $('.toc-menu li').removeClass('active');
              $('.toc-menu li').find(`a[href=#${sectionID}]`).parent().addClass('active');

              const toc = $('.toc-desktop');
              const containerPos = toc.find('.toc-menu').offset().top;
              let activeMenuPos = toc.find('.toc-menu li.active');

              if (activeMenuPos.length > 0) {
                activeMenuPos = activeMenuPos.offset().top;
              }

              const finalmenupos = activeMenuPos - containerPos + 15;

              $('.toc-menu').find('.progress-line').css('height', `${finalmenupos}px`);

              $('.toc-menu li.active').prev('li').addClass('passed');
              $('.toc-menu li.active').next('li').removeClass('passed');
            }
          }
        });

      if ($('.toc-menu li.active').is(':last-child')) {
        $('.toc-menu').addClass('last-elem-active');
      } else {
        $('.toc-menu').removeClass('last-elem-active');
      }
    }
  });
}

function isResized() {
  const imgWidth = $('.is-resized img').outerWidth();
  const figHeight = $('.is-resized figcaption').outerHeight();
  $('.is-resized figcaption').css('width', imgWidth).addClass('mx-auto');
  $('.is-resized figcaption').css('margin-top', `-${figHeight}px`);
}

function blogImage() {
  if (
    window.matchMedia('(max-width: 1199.98px)').matches &&
    window.matchMedia('(min-width: 667px)').matches
  ) {
    const blogHeaderHeight = $('.blog-header-info').outerHeight();
    // const blogHeaderInfoMargin = blogHeaderHeight - 30; // 30 value is space between logo and blog header info

    // $('.blog-header-info').css('margin-top', `-${blogHeaderInfoMargin}px`);
    $('.seniority-header-bg').css('padding-bottom', `${blogHeaderHeight}px`);
  } else {
    $('.blog-header-info').css('margin-top', '');
    $('.seniority-header-bg').css('padding-bottom', '');
  }
}

function blogMatchHeight() {
  $('.category-post .cat-post-container').matchHeight();
}
